import React from "react";
import PropTypes from "prop-types";

const RangeField = ({
  id,
  label,
  value,
  min,
  max,
  step,
  unit,
  onChange
}) => (
  <label className="range-field" htmlFor={id}>
    <div className="range-field__header">
      <span className="range-field__label">{label}</span>
      <span className="range-field__value">
        {value === "" ? "Any" : `${value}${unit ? ` ${unit}` : ""}`}
      </span>
    </div>
    <input
      id={id}
      type="range"
      min={min}
      max={max}
      step={step}
      value={value === "" ? min : value}
      onChange={event => onChange(event.target.value)}
    />
  </label>
);

RangeField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

RangeField.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  unit: ""
};

export default RangeField;
